// Phase 3.1 — ALM Alert types
// Phase 3.4 — EVE_BREACH + NIM_BREACH added

export type AlertType = 'LCR_BREACH' | 'NSFR_BREACH' | 'EVE_BREACH' | 'NIM_BREACH';
export type AlertSeverity = 'WARNING' | 'CRITICAL';

export interface AlmAlert {
  id: string;
  tenantId: string;
  alertType: AlertType;
  alertDate: string;           // ISO date string e.g. "2026-05-10"
  ratioValue: number;
  threshold: number;
  severity: AlertSeverity;
  acknowledged: boolean;
  acknowledgedBy: string | null;
  acknowledgedAt: string | null;
  createdAt: string;
}

export interface AlertListResponse {
  alerts: AlmAlert[];
  unacknowledgedCount: number;
}

export const ALERT_TYPE_LABELS: Record<AlertType, string> = {
  LCR_BREACH:  'LCR Breach',
  NSFR_BREACH: 'NSFR Breach',
  EVE_BREACH:  'EVE Outlier (IRRBB)',
  NIM_BREACH:  'NIM Stress Drop',
};
